"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpactProvider = exports.StakingContext = exports.RewardsContext = exports.EpochContext = exports.PACTBalanceContext = exports.CUSDBalanceContext = exports.ImpactProviderContext = void 0;
const tslib_1 = require("tslib");
const providers_1 = require("@ethersproject/providers");
const subgraphs_1 = require("./subgraphs");
const react_1 = tslib_1.__importStar(require("react"));
const initialEpoch = {
    donations: {
        everyone: 0,
        user: 0
    },
    endPeriod: undefined,
    initialised: false,
    rewards: 0,
    totalRaised: 0,
    userContribution: 0
};
const initialRewards = {
    allocated: 0,
    claimable: 0,
    currentEpoch: 0,
    estimated: 0,
    initialised: false
};
const intialProviderData = {
    // mandatory, value here doesn't matter
    address: null,
    jsonRpcUrl: null,
    networkId: null,
    provider: null,
    signer: null,
    subgraph: null,
    ubiManagementSubgraph: null
};
const initialStaking = {
    allocated: 0,
    claimableUnstaked: 0,
    estimateClaimableRewardByStaking: 0,
    generalAPR: 0,
    initialised: false,
    stakedAmount: 0,
    totalStaked: 0,
    unstakeCooldown: 0,
    userAPR: 0
};
const intialCUSDBalanceStateData = {
    balance: 0,
    setBalance: () => { }
};
const intialPACTBalanceStateData = {
    balance: 0,
    setBalance: () => { }
};
const intialEpochStateData = {
    epoch: initialEpoch,
    setEpoch: () => { }
};
const intialRewardsStateData = {
    rewards: initialRewards,
    setRewards: () => { }
};
const intialStakingStateData = {
    setStaking: () => { },
    staking: initialStaking
};
exports.ImpactProviderContext = react_1.default.createContext(intialProviderData);
exports.CUSDBalanceContext = react_1.default.createContext(intialCUSDBalanceStateData);
exports.PACTBalanceContext = react_1.default.createContext(intialPACTBalanceStateData);
exports.EpochContext = react_1.default.createContext(intialEpochStateData);
exports.RewardsContext = react_1.default.createContext(intialRewardsStateData);
exports.StakingContext = react_1.default.createContext(intialStakingStateData);
const CUSDBalanceProvider = react_1.default.memo((props) => {
    const { children } = props;
    const [cUSDBalance, setCUSDBalance] = (0, react_1.useState)(0);
    return (react_1.default.createElement(exports.CUSDBalanceContext.Provider, { value: {
            balance: cUSDBalance,
            setBalance: setCUSDBalance
        } }, children));
});
const PACTBalanceProvider = react_1.default.memo((props) => {
    const { children } = props;
    const [PACTBalance, setPACTBalance] = (0, react_1.useState)(0);
    return (react_1.default.createElement(exports.PACTBalanceContext.Provider, { value: {
            balance: PACTBalance,
            setBalance: setPACTBalance
        } }, children));
});
const EpochProvider = react_1.default.memo((props) => {
    const { children } = props;
    const [epoch, setEpoch] = (0, react_1.useState)(initialEpoch);
    return (react_1.default.createElement(exports.EpochContext.Provider, { value: {
            epoch,
            setEpoch
        } }, children));
});
const RewardsProvider = react_1.default.memo((props) => {
    const { children } = props;
    const [rewards, setRewards] = (0, react_1.useState)(initialRewards);
    return (react_1.default.createElement(exports.RewardsContext.Provider, { value: {
            rewards,
            setRewards
        } }, children));
});
const StakingProvider = react_1.default.memo((props) => {
    const { children } = props;
    const [staking, setStaking] = (0, react_1.useState)(initialStaking);
    return (react_1.default.createElement(exports.StakingContext.Provider, { value: {
            setStaking,
            staking
        } }, children));
});
const ImpactProvider = (props) => {
    const { children, address, jsonRpc, signer, networkId, apolloClientOptions, defaultFeeCurrency, connection } = props;
    return (react_1.default.createElement(exports.ImpactProviderContext.Provider, { value: {
            address,
            connection,
            defaultFeeCurrency,
            jsonRpcUrl: jsonRpc,
            networkId,
            provider: new providers_1.StaticJsonRpcProvider(jsonRpc),
            signer,
            subgraph: new subgraphs_1.ImpactMarketSubgraph(networkId, apolloClientOptions),
            ubiManagementSubgraph: new subgraphs_1.ImpactMarketUBIManagementSubgraph(new providers_1.StaticJsonRpcProvider(jsonRpc), networkId, apolloClientOptions)
        } },
        react_1.default.createElement(StakingProvider, null,
            react_1.default.createElement(RewardsProvider, null,
                react_1.default.createElement(EpochProvider, null,
                    react_1.default.createElement(PACTBalanceProvider, null,
                        react_1.default.createElement(CUSDBalanceProvider, null, children)))))));
};
exports.ImpactProvider = ImpactProvider;
//# sourceMappingURL=ImpactProvider.js.map